import { Injectable } from '@angular/core';
import { ApModalService } from 'webcommon/core-ui';
import { ApColorSelectorComponent } from './ap-color-selector.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApColorSelectorService {
  public appliedColorSubject = new BehaviorSubject<string>('');
  public appliedColor$ = this.appliedColorSubject.asObservable();

  constructor(private apModalService: ApModalService) {
  }

  public openModal(baseId: string, colorCode: string): Promise<boolean> {

    const initialState = {
      baseId,
      colorCode
    };

    const componentModal = this.apModalService.showComponentModal(ApColorSelectorComponent, {
      panelClass: ['emds-modal-medium', 'emds-modal-medium-fixed'],
      disableClose: true,
      initialState,
    });

    return componentModal;
  }

  public setAppliedColor(hexColor: string): void {
    this.appliedColorSubject.next(hexColor);
  }
}
